import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'

const Carousel = ({ images, name }) => {
  const [currentImage, setCurrentImage] = useState(0)

  const nextImage = () => {
    setCurrentImage((currentImage + 1) % images.length)
  }

  const prevImage = () => {
    setCurrentImage((currentImage - 1 + images.length) % images.length)
  }

  return (
    <div className='image-carousel'>
      <h2 className='carousel-title'>{name}</h2>
      <div className='carousel-container'>
        <button className='carousel-button left' onClick={prevImage}>
          <IconArrowLeft size={30} />
        </button>
        <img src={images[currentImage]} alt='Proyecto' className='carousel-image' />
        <button className='carousel-button right' onClick={nextImage}>
          <IconArrowRight size={30} />
        </button>
      </div>
    </div>
  )
}

Carousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired
}

export default Carousel
